import { createContext, useContext, type ReactNode } from 'react'

/**
 * Область действия увеличенной шкалы шрифтов (centrika-docs!31).
 *
 * Сама шкала — CSS-класс `.ds-work-scale` (канон токенов, `styles/tokens.css`): он переопределяет
 * значения токенов `--fs-*` на +2 px, и потомки получают увеличенные размеры по наследованию.
 * Рабочей области этого достаточно — класс висит на её контейнере.
 *
 * Порталам — нет: диалоги и выпадающие списки рендерятся в `document.body`, то есть вне DOM-
 * поддерева рабочей области, и наследование до них не доходит. Класс приходится ставить на сам
 * портал, но ТОЛЬКО когда он открыт из рабочей области: те же примитивы `Dialog`/`Select`
 * используются и на страницах входа/регистрации/восстановления пароля, которые остаются на
 * базовой шкале (иначе на регистрации список «Пол» рисовался бы крупнее своего же поля).
 *
 * Отсюда контекст: провайдер объявляет «здесь действует шкала рабочей области», а компонент с
 * порталом спрашивает `useWorkScaleClass()` и добавляет класс себе, если ответ положительный.
 * Провайдер ставится на кабинет целиком (каркас), а не только на `<main>`: диалог, открытый
 * каркасом кабинета (модалка онбординга), — тоже содержимое кабинета и идёт увеличенной шкалой,
 * тогда как страницы входа провайдера не имеют вовсе.
 */
const WorkScaleContext = createContext(false)

export function WorkScaleProvider({ children }: { children: ReactNode }) {
  return <WorkScaleContext.Provider value={true}>{children}</WorkScaleContext.Provider>
}

/**
 * Класс увеличенной шкалы для содержимого портала — или `undefined` вне рабочей области.
 * Возвращает именно класс (а не флаг), чтобы вызов подставлялся прямо в `cn(...)`.
 */
export function useWorkScaleClass(): string | undefined {
  return useContext(WorkScaleContext) ? 'ds-work-scale' : undefined
}
